export default __webpack_public_path__ + "static/media/arc.34975c50.png";